import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environment/environment';
import { AuthStore } from '../store/authentication/authentication.store';


export interface FileUploadDto {
  provider_id: number;
  document_type_id: number;
  filename: string;
  id?: number;
  document_id?: number;
  prefix?: string;
  licence_expire_date?: string | null;
  license_expire_date?: string | null;
  insurance_expire_date?: string | null;
}

export interface FileUploadS3Params {
    object_key: string
    bucket_name: string
}

export interface FileUploadS3PresignedUrl {
    presigned_s3_link: string
}

export interface FileUploadResponseDto extends FileUploadS3Params, FileUploadS3PresignedUrl{
  content_type: string
 }

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBase}`;

  /**
   * Get HTTP headers with authorization token if available
   */
  preFlightCommunicationFileUpload = (dto: FileUploadDto): Observable<FileUploadResponseDto> =>
    this.http.post<FileUploadResponseDto>(`${this.baseUrl}/provider/document`, dto).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error)))

  uploadFileToS3(url: string, content_type: string, file: File) {
    return this.http.put(url, file, {
      headers: new HttpHeaders({ 'Content-Type': content_type }),
      observe: 'response',
      responseType: 'text' as 'json',
      withCredentials: false
    });
  }
}
